import { addSavedCalendarView } from '../actions/publicActions';
import { getStore } from '../store/store';
import { SaveCalendarViewConfig } from '../store/schema/SaveCalendarViewConfig';
import { createSaveCalendarViewConfig } from '../utils/saveCalendarViewUtils';
import { mutator } from 'satcheljs';
import { upsertSavedCalendarViewService } from '../services/upsertSavedCalendarViewService';
import { logSaveViewsApiFailure } from '../utils/logServiceResponseUtil';

mutator(addSavedCalendarView, actionMessage => {
    let savedCalendarViewConfig: SaveCalendarViewConfig = createSaveCalendarViewConfig(
        actionMessage.draftSaveCalendarViewConfig
    );
    let response = upsertSavedCalendarViewService(savedCalendarViewConfig);
    if (response != null) {
        getStore().savedViewMap.set(savedCalendarViewConfig.id, savedCalendarViewConfig);
        getStore().currentlyDisplayedViewId = savedCalendarViewConfig.id;
    } else {
        logSaveViewsApiFailure('add');
    }
});
